import { render } from "./AlbumDeleteModal.vue?vue&type=template&id=2be3b622&ts=true"
import script from "./AlbumDeleteModal.vue?vue&type=script&lang=ts"
export * from "./AlbumDeleteModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__